import { LogOut, Plus } from "lucide-react";
import { Link, useNavigate } from "react-router";
import { useAuth } from "../auth/AuthContext";
import { ICON } from "../components/ui";
import { MOBILE_TABS, NAV_FLAT } from "./nav";

/** Mobile "Mai mult" (prototype `moreItems` + `moreLogout`): sections outside the bottom navigation. */
export function MorePage() {
  const { logout, state } = useAuth();
  const navigate = useNavigate();
  const rest = NAV_FLAT.filter((i) => !(MOBILE_TABS as readonly string[]).includes(i.id));
  return (
    <>
      <h1 className="h1">Mai mult</h1>
      <ul className="nav-list card" style={{ padding: 8 }}>
        {rest.map((i) => (
          <li key={i.id}>
            <Link to={i.path} className="nav-item">
              <i.icon {...ICON} aria-hidden="true" />
              {i.label}
            </Link>
          </li>
        ))}
        {state.status === "authenticated" && !state.me.support && (
          <li>
            <a href="/app/restaurant-nou" className="nav-item">
              <Plus {...ICON} aria-hidden="true" />
              Adaugă un restaurant
            </a>
          </li>
        )}
        <li>
          <button
            type="button"
            className="nav-item"
            style={{ width: "100%", border: 0, background: "transparent" }}
            onClick={async () => {
              await logout();
              navigate("/login", { replace: true });
            }}
          >
            <LogOut {...ICON} aria-hidden="true" />
            Deconectare
          </button>
        </li>
      </ul>
    </>
  );
}
